import { Perfil } from '../models/perfil.interface';

export interface PerfilState {
  perfiles: Perfil[];
  selectedPerfil: Perfil | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  searchResults: Perfil[];
  searchQuery: string;
}

export const initialPerfilState: PerfilState = {
  perfiles: [],
  selectedPerfil: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  deleting: false,
  searchResults: [],
  searchQuery: ''
};
